import { Card, Col } from 'antd';
import React from 'react';
export const WidgetsCard = (props) => {
	const { setActionCard, item } = props;
	return (
		<Col span={12} key={item?.module_id} className="my-2">
			<Card
				bordered={false}
				className="text-center"
				style={{
					border: '1px solid #d9d9d9',
					borderRadius: '8px',
					boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
				}}
				onClick={() =>
					setActionCard({
						isActionCard: true,
						cardActionData: item?.title && item,
						slug: item?.search_panel_slug,
					})
				}
			>
				<i className={`${item.icon_class}`} style={{ fontSize: '35px', color: '#419aed' }}></i>
				<p className="mb-0 mt-3 title"> {item?.title} </p>
				<p style={{ color: '#888', fontSize: '12px', marginBottom: 0 }}> {item?.subtitle} </p>
			</Card>
		</Col>
	);
};
